import React, {Component} from 'react';
import TableRow from '../TableRow';
import TableInput from '../TableInput';
import TableControls from '../TableControls';
import {getNumber} from '../../../../utils/isValidUrl';
import ReactPaginate from 'react-paginate';
import FacebookLogo from '../../../../../../common/img/icons/facebook-logo.svg';
import PinterestLogo from '../../../../../../common/img/icons/pinterest-logo.svg';
import SharedcountMinLogo from '../../../../../../common/img/icons/sharedcount-min-logo.svg';
import CsvExport from '../../../../../../common/img/icons/csv-export.svg';
import LeftArrow from '../../../../../../common/img/icons/pages-arrow-l.svg';
import RightArrow from '../../../../../../common/img/icons/page-arrow-r.svg';
import {CSVLink} from "react-csv";

export default class TableView extends Component {
    state = {
        rowsPerPage: 10,
        invalidUrls: [],
        invalidUrlMessage: 'Invalid URL'
    };

    handleInvalidUrls = (invalidUrls) => {
        this.setState({invalidUrls: this.state.invalidUrls.concat(invalidUrls)});
    };

    handleClearTable = () => {
        this.props.handleClearData();
        this.setState({invalidUrls: []});
    };

    handleDeleteInvalidUrlRow = url => {
        this.setState({
            invalidUrls: this.state.invalidUrls.filter(item => url !== item)
        });
    };

    render() {
        const {rowsPerPage, invalidUrlMessage, invalidUrls} = this.state;
        const {activePage} = this.props;

        const totalData = {
            facebook: this.props.data.reduce((accumulator, el) => accumulator + el.data.Facebook.total_count, 0),
            pinterest: this.props.data.reduce((accumulator, el) => accumulator + el.data.Pinterest, 0),
        };

        const csvHeaders = [
            { label: "№", key: "index" },
            { label: "URLs", key: "url" },
            { label: "Facebook shares", key: "fbShares" },
            { label: "Facebook comments", key: "fbComments" },
            { label: "Facebook comments plugin", key: "fbCommentsPlugin" },
            { label: "Facebook reactions", key: "fbReactions" },
            { label: "Facebook total", key: "fbTotal" },
            { label: "Pins", key: "pin" },
            { label: "Total", key: "total" },
        ];

        let csvData = [];
        this.props.data.forEach((line, index) => {
            if(!line.data){
                csvData.push([index + 1, line.url, 0, 0, 0, 0, 0, 0, 0]);
            } else{
                const {Facebook, Pinterest} = line.data;
                const total = Facebook.total_count + Pinterest;
                csvData.push({
                    index: index + 1,
                    url: line.url,
                    fbShares: Facebook.share_count,
                    fbComments: Facebook.comment_count,
                    fbCommentsPlugin: Facebook.comment_plugin_count,
                    fbReactions: Facebook.reaction_count,
                    fbTotal: Facebook.total_count,
                    pin: Pinterest,
                    total: total
                })
            }
        });

        invalidUrls.forEach((item, index) => {
            csvData.push({index: csvData.length + 1 + index, url: item, fbShares: invalidUrlMessage, fbComments: invalidUrlMessage, fbCommentsPlugin: invalidUrlMessage, fbReactions: invalidUrlMessage, fbTotal: invalidUrlMessage, pin: invalidUrlMessage, total: invalidUrlMessage})
        });

        const data = this.props.data.concat(invalidUrls.map(url => ({invalid:true, url, data: {Facebook: {}, Pinterest: {}}})));
        const pageCount = Math.ceil((this.props.data.length + invalidUrls.length) / this.state.rowsPerPage);
        const totalStyle = {
            textAlign: "right",
            display: "inline-block",
            width: "calc(100% - 300px)"
        };

        return (
            <div className="row tab">
                <TableInput
                    errorMessage={this.props.errorMessage}
                    isRequestPending={this.props.isRequestPending}
                    defaultInputValue={this.props.defaultInputValue}
                    requestAPI={this.props.requestAPI}
                    data={this.props.data}
                    user={this.props.user}
                    handleInvalidUrls={this.handleInvalidUrls}
                />

                {this.props.data.length > 0 || invalidUrls.length > 0
                    ? [
                        <table className="table__content table__content_visible" key="table">
                            <thead>
                            <tr>
                                <th className="centered table-index-hide">№</th>
                                <th>URLs</th>
                                <th className="td-disp-none">
                                    <div className="th-wrap">
                                        <img src={FacebookLogo} alt=""/>
                                        <span>Facebook</span>
                                    </div>
                                </th>
                                <th className="td-disp-none">
                                    <div className="th-wrap">
                                        <img src={PinterestLogo} alt=""/>
                                        <span>Pins</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-wrap">
                                        <img src={SharedcountMinLogo} alt=""/>
                                        <span>Total</span>
                                    </div>
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            {data
                                .slice(activePage * rowsPerPage, (activePage + 1) * rowsPerPage)
                                .map((el, index) => (
                                    <TableRow
                                        isInvalid={el.invalid}
                                        rowData={el}
                                        key={index + Date.now()}
                                        index={activePage * rowsPerPage + index + 1}
                                        data={this.props.data}
                                        handleChangeTableRow={this.props.handleChangeTableRow}
                                        handleDeleteTableRow={this.props.handleDeleteTableRow}
                                        handleDeleteInvalidUrlRow={this.handleDeleteInvalidUrlRow}
                                        invalidUrlMessage={invalidUrlMessage}
                                        requestAPI={this.props.requestAPI}
                                        user={this.props.user}
                                        handleInvalidUrls={this.handleInvalidUrls}
                                    />
                                ))}

                                <tr className="tb-line tb-line_active tb-line_total ">
                                    <td colSpan="2" className="table__info-controls hidden-sm">
                                        <CSVLink data={csvData} headers={csvHeaders} filename="sharedCountExport.csv">
                                            <button className="hidden-mobile">
                                                <img src={CsvExport} alt=""/>
                                                <span>Export to CSV</span>
                                            </button>
                                        </CSVLink>
                                        <button className="hidden-mobile" onClick={this.handleClearTable}>
                                            Clear all
                                        </button>
                                        <span style={totalStyle}>
                                        Total
                                        </span>
                                    </td>
                                    <td className="tb-data tb-data_face">{getNumber(totalData.facebook)}</td>
                                    <td className="tb-data tb-data_pins">{getNumber(totalData.pinterest)}</td>
                                    <td className="tb-data tb-data__total">
                                        {getNumber(totalData.facebook + totalData.pinterest)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>,
                        pageCount > 1 ?
                        <ReactPaginate
                            previousLabel={
                                <img className="pagination-arrow" src={LeftArrow} alt=""/>
                            }
                            nextLabel={<img className="pagination-arrow" src={RightArrow} alt=""/>}
                            // breakLabel={<a>...</a>}
                            // breakClassName={'break-me'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={4}
                            onPageChange={this.props.handlePageChange}
                            containerClassName={'table-pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                            key="pagination"
                        /> : null,
                        <TableControls
                            handleClearTable={this.handleClearTable}
                            key="table-controls"
                            csvData={csvData}
                            csvHeaders={csvHeaders}
                            data={this.props.data}
                        />,
                    ]
                    : false}
            </div>
        );
    }
}
